export default __webpack_public_path__ + "static/media/acropass-ac-care-temporary.989aeaaf.png";